import React from "react";
import useChooseUserToClient from "./hooks";
import { MultiPickerListProps } from "../props";
import MultiPickerListWithSelectedItems from "../MultiPickerListWithSelectedItems";
import UserWithAvatar from "components/Atoms/UserWithAvatar";

interface Props extends MultiPickerListProps<server.dto.UserToClientSmall> {
  canChooseDeactivated?: boolean
  environment: server.dto.Environments | "both"
}

const MultiUserToClientList = (props: Props) => {
  const chooseUserToClient = useChooseUserToClient({ environment: props.environment === "both" ? "internal" : props.environment });

  const displayLifecycles = props.canChooseDeactivated;
  const displayEnvironment = props.environment === "both";

  const isActiveSelected = chooseUserToClient.instruction.lifeCycles.includes("active");
  const isDeactivatedSelected = chooseUserToClient.instruction.lifeCycles.includes("archived");

  const isInternalSelected = chooseUserToClient.instruction.environment === "internal";
  const isExternalSelected = chooseUserToClient.instruction.environment === "external";

  return <MultiPickerListWithSelectedItems
    instruction={chooseUserToClient.instruction}
    onInstructionChange={i => chooseUserToClient.setInstruction(i)}
    queryKey="multiUserToClients"
    api={instruction => window.CoreApi.UserToClient.PaginatedSmall(instruction)}

    getError={() => undefined}
    excludeKeys={props.excludeKeys}

    onChange={props.onChange}
    renderListItem={userToClient => <UserWithAvatar user={userToClient.user} avatarSize="avatar" />}
    getId={userToClient => userToClient.userToClientId}
    getLabel={userToClient => <div>{userToClient.user.fullName}</div>}
    value={props.value}

    filter1={displayEnvironment
      ? {
        leftButton: {
          type: "tertiary",
          isActive: isInternalSelected,
          label: RESX.UserType.Internal,
          onClick: () => { chooseUserToClient.setEnvironment("internal"); }
        },
        rightButton: {
          type: "tertiary",
          isActive: isExternalSelected,
          label: RESX.UserType.External,
          onClick: () => { chooseUserToClient.setEnvironment("external"); }
        }
      }
      : undefined}

    filter2={displayLifecycles
      ? {
        leftButton: {
          type: "primary",
          isActive: isActiveSelected,
          label: RESX.SoUser.Active,
          onClick: () => { chooseUserToClient.setLifecycles(["active"]); }
        },
        rightButton: {
          type: "warning",
          isActive: isDeactivatedSelected,
          label: RESX.SoUser.Deactivated,
          onClick: () => { chooseUserToClient.setLifecycles(["archived"]); }
        }
      }
      : undefined}
  />
};

export default MultiUserToClientList;